<div class="sales-order-invoice-ids-cell-renderer--container">
  <mat-chip
    *ngFor="let invoice of invoices; trackBy: trackById"
    class="lum-chip lum-chip--small mr-2"
    disableRipple
    (click)="openInvoiceInNewTab(invoice?.id)"
  >
    {{ invoice?.id }}
  </mat-chip>
</div>
